export default {
  email: 'Please enter a valid email address.',
  firstName: 'Please enter your first name.',
  lastName: 'Please enter your last name.',
  name: 'Please enter a name.',
  title: 'Please enter a title.',
  phone: 'Phone number must be between 7 and 20 characters long',
  privacyPolicy: 'Please agree to the privacy policy.',
  termsAndConditions: 'Please agree to the terms and conditions.',
  termsAndConditionsPrivacy: 'Please agree to the Terms and Conditions and Privacy Policy.',
  // Password
  password: {
    lowercase: 'Password must contain at least one lowercase letter.',
    match: 'The passwords do not match.',
    min: 'Password must be at least 8 characters long.',
    max: 'Password must be at most 255 characters long.',
    number: 'Password must contain at least one number.',
    required: 'Password is required.',
    special: 'Password must contain at least one special character.',
    uppercase: 'Password must contain at least one uppercase letter.',
  },
  passwordConfirm: 'Passwords do not match.',
}
